export enum BucketVendors {
	AWS,
	FIREBASE
}
